import React, { useEffect, useState } from 'react'
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import ListItemText from '@material-ui/core/ListItemText'
import ListItem from '@material-ui/core/ListItem'
import List from '@material-ui/core/List'
import Divider from '@material-ui/core/Divider'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import IconButton from '@material-ui/core/IconButton'
import Typography from '@material-ui/core/Typography'
import CloseIcon from '@material-ui/icons/Close'
import Slide from '@material-ui/core/Slide'

import { connect } from 'react-redux'

import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogContentText from '@material-ui/core/DialogContentText'
import DialogTitle from '@material-ui/core/DialogTitle'

import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import Paper from '@material-ui/core/Paper'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    appBar: {
      position: 'relative'
    },
    title: {
      marginLeft: theme.spacing(2),
      flex: 1
    },

    root: {
      width: '100%'
    },
    heading: {
      fontSize: theme.typography.pxToRem(15),
      flexBasis: '33.33%',
      flexShrink: 0
    },
    secondaryHeading: {
      fontSize: theme.typography.pxToRem(15),
      color: theme.palette.text.secondary
    }
  })
)

function ReviewSectionEnrollment(props) {
  const classes = useStyles()

  const { selectedCourses, courseSectionUserData } = props

  const [open, setOpen] = React.useState(false)

  const [dialogUserList, setDialogUserList] = useState('')

  const handleClickOpen = (userList) => {
    setOpen(true)
    setDialogUserList(userList)
  }

  const handleCloseDialog = () => {
    setDialogUserList('NO DATA')

    setOpen(false)
  }

  // const   radioDefaultValue = csvActionType;

  return (
    <React.Fragment>
      <Typography variant='h6' gutterBottom>
        Summary
      </Typography>

      <div className={classes.root}>
        <TableContainer component={Paper}>
          <Table className={classes.table} aria-label='simple table'>
            <TableHead>
              <TableRow>
                <TableCell>Course Name</TableCell>
                <TableCell align='right'>Section</TableCell>
                <TableCell align='right'>Role</TableCell>

                <TableCell align='right'>Action Type</TableCell>

                <TableCell align='right'>Enroll Count</TableCell>
                <TableCell align='right'>User List</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {selectedCourses.map((parent) =>
                courseSectionUserData.data.map((child) => {
                  if (typeof child[parent.id] !== 'undefined') {
                    return child[parent.id].map((item) => {
                      if (item.text != '') {
                        return (
                          <TableRow
                            key={`row-${item.sis_course_id}-${item.sec}`}
                          >
                            <TableCell component='th' scope='row'>
                              {parent.name}
                            </TableCell>
                            <TableCell align='right'>{item.sec}</TableCell>
                            <TableCell align='right'>
                              {item.role.label}
                            </TableCell>

                            <TableCell align='right'>
                              {item.actionType === 'active' ? 'Add' : 'Remove'}
                            </TableCell>

                            <TableCell align='right'>
                              {item.text.split(',').length}
                            </TableCell>
                            <TableCell align='right'>
                              <Button
                                variant='outlined'
                                color='primary'
                                onClick={() => handleClickOpen(item.text)}
                              >
                                View List
                              </Button>
                            </TableCell>
                          </TableRow>
                        )
                      }
                    })
                  }
                })
              )}
            </TableBody>
          </Table>
        </TableContainer>

        <Dialog
          fullWidth={true}
          maxWidth={'sm'}
          open={open}
          onClose={handleCloseDialog}
          aria-labelledby='form-dialog-title'
        >
          <DialogTitle id='form-dialog-title'>User List</DialogTitle>
          <DialogContent>
            <DialogContentText>
              {dialogUserList.split(',').map((item) => (
                <ListItem key={`item-${item}`}>
                  <ListItemText primary={`${item}`} />
                </ListItem>
              ))}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseDialog} color='primary'>
              ok
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    </React.Fragment>
  )
}

function mapStateToProps(state) {
  return {
    courseSectionUserData: state.CourseLevelAdmin.courseSectionUserData,
    selectedCourses: state.CourseLevelAdmin.summery.courses
  }
}

export default connect(mapStateToProps, {})(ReviewSectionEnrollment)
